var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elements-/-Actions-/-Edit",
    transform: "translate(-27.000000, -27.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(15.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.000000, 12.000000)",
    id: "Edit"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.03916667,0 L7.3725,1.66666667 L1.66666667,1.66666667 L1.66666667,13.3333333 L4.14916667,13.3333333 C4.1775,13.3341667 4.205,13.3416667 4.2325,13.3416667 L4.2325,13.3416667 L4.29833333,13.3333333 L13.3333333,13.3333333 L13.3333333,7.77666667 L15,6.11 L15,13.3333333 C15,14.2525 14.2525,15 13.3333333,15 L13.3333333,15 L1.66666667,15 C0.7475,15 0,14.2525 0,13.3333333 L0,13.3333333 L0,1.66666667 C0,0.7475 0.7475,0 1.66666667,0 L1.66666667,0 L9.03916667,0 Z M11.0154239,0.451801319 C11.6134691,-0.149396372 12.6652314,-0.152607041 13.268061,0.454209321 L13.268061,0.454209321 L14.5327273,1.72723941 C14.8341421,2.03064759 15,2.4335865 15,2.86221076 C15,3.29083501 14.8341421,3.69377392 14.5327273,3.9971821 L14.5327273,3.9971821 L6.85223156,11.6546267 L3.33333333,11.6666667 L3.33333333,8.11085122 Z M9.73640444,3.98594476 L4.92812066,8.78027561 L4.92812066,10.0557137 L6.1935844,10.0517004 L11.0010708,5.25897485 L9.73640444,3.98594476 Z M12.1405463,1.58918066 L10.8695008,2.85739475 L12.1341672,4.12962218 L13.4076049,2.85980275 L12.1405463,1.58918066 Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.098db5e9.svg";
export { ForwardRef as ReactComponent };